var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-container"},[_c('div',{staticClass:"grid"},_vm._l((_vm.agents),function(agent){return _c('AgentCard',{key:agent.id,attrs:{"agent":agent}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }